<script>
import AkLabel from '@components/v2/general/AkLabel.vue';

export default {
  name: 'AkSelect',
  components: {AkLabel},
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
    mobileNoLabel: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      indicatorStyle: {opacity: 0},
      optionRefs: [],
    };
  },
  watch: {
    modelValue: {
      handler() {
        this.updateIndicator();
      },
      flush: 'post',
    },
    options: {
      handler() {
        this.updateIndicator();
      },
      flush: 'post',
    },
  },
  mounted() {
    this.updateIndicator();
    window.addEventListener('resize', this.updateIndicator);
  },
  beforeUpdate() {
    this.optionRefs = [];
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIndicator);
  },
  methods: {
    setOptionRef(el, index) {
      if (el) {
        this.optionRefs[index] = el;
      }
    },
    updateIndicator() {
      const index = this.options.findIndex((option) => option.value === this.modelValue);
      if (index !== -1 && this.optionRefs[index]) {
        const el = this.optionRefs[index];
        this.indicatorStyle = {
          left: `${el.offsetLeft}px`,
          top: `${el.offsetTop}px`,
          width: `${el.offsetWidth}px`,
          height: `${el.offsetHeight}px`,
          opacity: 1,
        };
      } else {
        this.indicatorStyle = {opacity: 0};
      }
    },
    setValue(value) {
      this.$emit('update:modelValue', value);
      if (value !== this.modelValue) {
        this.$emit('change', value);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2.5">
    <AkLabel v-if="label">
      {{ label }}
    </AkLabel>

    <div class="border border-grey-100 flex relative" :class="xs ? 'p-1 rounded-[10px]' : 'p-2 rounded-lg'">
      <div class="absolute bg-primary rounded-6 transition-all duration-300 ease-in-out" :style="indicatorStyle"></div>
      <div
        v-for="(option, index) in options"
        :key="option.value"
        :ref="(el) => setOptionRef(el, index)"
        class="flex gap-2 items-center rounded-6 cursor-pointer select-none relative z-10 transition-colors duration-300"
        :class="[
          {'text-white': option.value === modelValue, 'text-grey-900': option.value !== modelValue},
          xs ? 'p-1' : 'md:px-4 px-2 py-2',
        ]"
        @click="setValue(option.value)">
        <i v-if="option.icon" :class="[option.icon, xs ? 'text-md' : 'text-3xl']" />
        <span
          v-if="option.label && (mobileNoLabel ? !this.$isMobile() : true)"
          class="font-medium"
          :class="{'px-1.5': xs}"
          >{{ option.label }}</span
        >
      </div>
    </div>
  </div>
</template>

<style scoped></style>
